import React from 'react';
import { Link } from 'react-router-dom';

export default function GeneralBlog() {
    return (
        <section className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold mb-6 text-center border-b-2 border-blue-500 pb-2">
                Blogs
            </h1>
            <div className="grid gap-6">
                {/* Internal Blog Entry */}
                <div className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                    <h2 className="text-xl font-semibold mb-2 text-blue-800">
                        Two Years at CSE, IITH: A Journey of Growth and Discovery
                    </h2>
                    <p className="mb-4 text-gray-700">
                        A reflective look back on my M.Tech journey at IITH—covering academics, research, growth, and friendship.
                    </p>
                    <Link to="/blog/mtechcse@iith" className="text-blue-600 font-medium hover:underline">
                        Read more →
                    </Link>
                </div>

                {/* LinkedIn Blog 1: WTF 2024 */}
                <a
                    href="https://www.linkedin.com/posts/agarwalkritik_wtf2024-machinelearning-datascience-activity-7256054979558334464-yyt7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow block"
                >
                    <h2 className="text-xl font-semibold mb-2 text-blue-800">
                        Meeting Krish Naik at WTF 2024 – A Fan Moment!
                    </h2>
                    <p className="mb-4 text-gray-700">
                        From watching ML tutorials to meeting the legend in person—my unforgettable interaction with Krish Naik and Hitesh Choudhary at the WTF Summit by Tinkerers' Lab, IITH.
                    </p>
                    <span className="text-blue-600 font-medium hover:underline">Read on LinkedIn →</span>
                </a>

                {/* LinkedIn Blog 2: prAkshepan */}
                <a
                    href="https://www.linkedin.com/posts/agarwalkritik_prakshepan-departmentofcse-cse-activity-7225824357875335169-4Ue1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow block"
                >
                    <h2 className="text-xl font-semibold mb-2 text-blue-800">
                        prAkshepan 2.0 – Leading, Learning & Celebrating CSE@IITH
                    </h2>
                    <p className="mb-4 text-gray-700">
                        A deep dive into organizing prAkshepan 2.0 — building community, guiding juniors, and celebrating our vibrant CSE culture at IIT Hyderabad.
                    </p>
                    <span className="text-blue-600 font-medium hover:underline">Read on LinkedIn →</span>
                </a>

                {/* Sunshine Newsletter */}
                <a
                    href="https://sunshine.iith.ac.in/newsletter"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow block"
                >
                    <h2 className="text-xl font-semibold mb-2 text-blue-800">
                        Healing and Hope – My Story in the Sunshine Newsletter
                    </h2>
                    <p className="mb-4 text-gray-700">
                        Life, like a game, gets tougher with each level. But mistakes teach us something new. Read my story in the Sunshine newsletter, where I share my journey of healing and hope during the pandemic. I hope it inspires you to find your own strength in tough times.
                        <br /><br />
                        Published in Volume 4 of <strong>Sunshine</strong> (IITH's Mental Wellness Newsletter), this article is a heartfelt reflection on my journey through the pandemic and the lessons learned along the way.
                    </p>
                    <span className="text-blue-600 font-medium hover:underline">Read in Sunshine →</span>
                </a>


                {/* LinkedIn Blog 3: CMRU Farewell */}
                <a
                    href="https://www.linkedin.com/posts/agarwalkritik_cmruniversity-btechjourney-gratitude-activity-7069334938633854976-_maf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow block"
                >
                    <h2 className="text-xl font-semibold mb-2 text-blue-800">
                        A Heartfelt Farewell to CMRU: A Journey of Growth and Gratitude
                    </h2>
                    <p className="mb-4 text-gray-700">
                        A heartfelt tribute to my professors, mentors, and peers at CMRU as I reflect on four transformative years of my B.Tech journey.
                    </p>
                    <span className="text-blue-600 font-medium hover:underline">Read on LinkedIn →</span>
                </a>
            </div>
        </section>
    );
}
